<template>
  <div class="customer-manager-container">
    <BankBalance
      ref="bankBalanace"
      :projectUID="projectUID"
      :customerUID="customerUID"
      :apiMode="apiMode"
      :bank-account-numbers="dataBankAccountTable.length"
      :showAccountNumber="showAccountNumber"
    />
    <el-tabs v-model="tabActive">
      <el-tab-pane label="Bank Account" name="bankaccount">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span><i class="el-icon-money"></i> Bank Accounts</span>
            <el-button
              v-if="superRole"
              icon="el-icon-plus"
              style="float: right; padding: 0"
              type="text"
              @click="showDialog('add')"
              >Create Bank Account</el-button
            >
            <el-button
              v-if="superRole"
              icon="el-icon-s-finance"
              style="float: right; padding: 0 10px"
              type="text"
              @click="showSimulatePayment()"
              >Simulator Payment</el-button
            >
          </div>
          <div class="table-data-customer">
            <div class="btn-status">
              <el-button
                type="primary"
                size="small"
                plain
                @click="getDataSelect()"
                >All</el-button
              >
              <el-button
                type="success"
                size="small"
                plain
                @click="getDataSelect('active')"
                >Active</el-button
              >
              <el-button
                type="info"
                size="small"
                plain
                @click="getDataSelect('suspended')"
                >Suspended</el-button
              >
              <el-button
                type="danger"
                size="small"
                plain
                @click="getDataSelect('closed')"
                >Closed</el-button
              >
            </div>
            <data-tables
              v-loading="loadingBankAccount"
              :data="dataBankAccountTableSelect"
              border
              :page-size="10"
              :pagination-props="{
                background: true,
                pageSizes: [5, 10, 20, 50, 100],
              }"
            >
              <el-table-column
                prop="status"
                label="Status"
                header-align="center"
                align="center"
                width="100"
                fixed
              >
                <template slot-scope="scope">
                  <el-tag
                    v-if="scope.row.status === 'active'"
                    type="success"
                    size="small"
                    >{{ scope.row.status && scope.row.status.toUpperCase() }}</el-tag
                  >
                  <el-tag
                    v-if="scope.row.status === 'closed'"
                    type="danger"
                    size="small"
                    >{{ scope.row.status && scope.row.status.toUpperCase() }}</el-tag
                  >
                  <el-tag
                    v-if="scope.row.status === 'suspended'"
                    type="info"
                    size="small"
                    >{{ scope.row.status && scope.row.status.toUpperCase() }}</el-tag
                  >
                </template>
              </el-table-column>
              <!-- width = sum of child columns, el-table uses it for fixed column width -->
              <el-table-column
                v-if="contractRole"
                label="Contract"
                label-class-name="contract-header"
                header-align="center"
                width="180"
                fixed
              >
                <el-table-column
                  v-for="item in contractColumns"
                  :key="item.prop"
                  :prop="item.prop"
                  :label="item.label"
                  header-align="center"
                  align="center"
                  width="90"
                >
                  <template slot-scope="scope">
                    <el-tag
                      :type="contractTagType(scope.row[item.prop])"
                      size="small"
                      >{{ contractStatusText(scope.row[item.prop]) }}</el-tag
                    >
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column
                prop="bankholderID"
                label="BankholderID"
                header-align="center"
                align="center"
                width="120"
                fixed
              ></el-table-column>
              <el-table-column
                prop="member_code"
                label="Member code"
                header-align="center"
                align="center"
                width="110"
                fixed
                v-if="apiMode === 'customer'"
              ></el-table-column>
              <el-table-column
                prop="name"
                label="Name"
                header-align="center"
                align="center"
                width="220"
                v-if="apiMode === 'customer'"
              >
                <template slot-scope="scope">
                  {{ scope.row.name || scope.row.name2 }}
                </template>
              </el-table-column>
              <el-table-column
                prop="currency"
                label="Currency"
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.currency && scope.row.currency.toUpperCase() }}
                </template>
              </el-table-column>
              <el-table-column
                prop="referenceID"
                label="Ref"
                header-align="center"
                align="center"
                width="150"
              ></el-table-column>
              <el-table-column
                prop="accountnumber"
                label="Account Number"
                header-align="center"
                align="center"
                width="120"
              ></el-table-column>
              <el-table-column
                prop="sortcode"
                label="Sort Code"
                header-align="center"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="iban"
                label="Iban"
                header-align="center"
                align="center"
                width="200"
              ></el-table-column>
              <el-table-column
                prop="bic"
                label="Bic"
                header-align="center"
                align="center"
                width="150"
              ></el-table-column>
              <el-table-column
                prop="type"
                label="Type"
                header-align="center"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="purpose"
                label="Purpose"
                header-align="center"
                align="center"
                width="100"
              ></el-table-column>
              <el-table-column
                prop="created_date"
                label="Created"
                header-align="center"
                align="center"
                width="150"
              ></el-table-column>
              <el-table-column
                prop="updated_date"
                label="Updated"
                header-align="center"
                align="center"
                width="150"
              ></el-table-column>
              <el-table-column
                prop="Id"
                label="Action"
                header-align="left"
                align="center"
                :width="contractRole ? 410 : 300"
                fixed="right"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.bankholderID">
                    <el-button
                      v-if="flag_flowfund && apiMode === 'customer'"
                      icon="el-icon-money"
                      type="success"
                      size="mini"
                      @click="
                        showDepositTopup(
                          scope.row.bankholderID,
                          scope.row.currency
                        )
                      "
                      >Deposit</el-button
                    >
                    <el-button
                      v-if="flag_flowfund && apiMode === 'project'"
                      icon="el-icon-money"
                      type="success"
                      size="mini"
                      @click="
                        showTransfer(scope.row.bankholderID, scope.row.currency)
                      "
                      >Transfer</el-button
                    >
                    <el-button
                      icon="el-icon-circle-check"
                      type="primary"
                      size="mini"
                      @click="
                        $router.push(
                          `/bank-account/view/${apiMode}/${scope.row.bankholderID}`
                        )
                      "
                      >View</el-button
                    >
                    <el-button
                      v-if="!readonlyMode || superRole"
                      icon="el-icon-edit"
                      type="warning"
                      size="mini"
                      @click="showDialog('edit', scope.row.bankholderID)"
                      >Edit</el-button
                    >
                    <el-button
                      v-if="!readonlyMode && scope.row.status != 'closed'"
                      icon="el-icon-circle-close"
                      type="danger"
                      size="mini"
                      @click="deleteBankAccount(scope.row.bankholderID)"
                      >Close</el-button
                    >
                    <el-dropdown
                      v-if="contractRole && scope.row.status === 'active'"
                      trigger="click"
                      class="contract-dropdown"
                      @command="(type) => showContract(scope.row, type)"
                    >
                      <el-button icon="el-icon-document" type="info" size="mini"
                        >Contract<i class="el-icon-arrow-down el-icon--right"></i
                      ></el-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="monthly">Monthly</el-dropdown-item>
                        <el-dropdown-item command="compliance">Compliance</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </template>
              </el-table-column>
            </data-tables>
          </div>

          <FormBankAccount
            ref="formBankAccount"
            :projectUID="projectUID"
            :customerUID="customerUID"
            :apiMode="apiMode"
            v-on:submited="submitedFormBankAccount"
          />
          <FormDepositTopup
            ref="formDepositTopup"
            v-on:submited="submitedDepositTopup"
          />
          <FormSimulatePayment
            ref="formSimulatePayment"
            v-on:submited="submitedSimulatePayment"
          />
          <FormTransfer ref="formTransfer" v-on:submited="submitedTransfer" />
          <FormPayment ref="formPayment" v-on:submited="submitedTransfer" />
          <ContractForm
            v-if="contractRole"
            ref="contractForm"
            v-on:submited="submitedContract"
          />
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="Card" name="card" v-if="apiMode === 'customer'">
        <CardManager :customerUID="customerUID" />
      </el-tab-pane>
      <el-tab-pane label="Debt" name="debt" v-if="apiMode === 'customer'">
        <DebtEnduser :customerUID="customerUID" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import BankBalance from "@/views/bank-account/components/balance";
import FormBankAccount from "@/views/bank-account/components/form-bankaccount";
import FormDepositTopup from "@/views/bank-account/components/form-deposit-topup";
import FormSimulatePayment from "@/views/bank-account/components/form-simulate-payment";
import FormTransfer from "@/views/bank-account/components/form-transfer";
import CardManager from "@/views/card/components/card-manager";
import FormPayment from "@/views/bank-account/components/bank-payment";
import DebtEnduser from "@/views/bank-account/components/debt-enduser";
import ContractForm from "@/views/customer/components/contract-form";
import {
  getBankAccountByProject,
  getBankAccountBy,
  getBankAccountByCustomer,
  deleteBankAccount,
} from "@/api/bank-account";
import { getContractList } from "@/api/customer";
import { findObjectArray } from "@/utils";
import { mapGetters } from "vuex";

export default {
  components: {
    BankBalance,
    FormBankAccount,
    FormDepositTopup,
    FormSimulatePayment,
    FormTransfer,
    CardManager,
    FormPayment,
    DebtEnduser,
    ContractForm,
  },
  props: {
    projectUID: String,
    customerUID: String,
    readonlyMode: {
      type: Boolean,
      default: false,
    },
    showAccountNumber: {
      type: Boolean,
      default: true,
    },
    apiMode: String,
  },
  computed: {
    ...mapGetters(["flag_flowfund"]),
    adminSuperAdmin() {
      return this.roleAuth([this.role.spadmin, this.role.admin]);
    },
    superRole() {
      return this.roleAuth([this.role.spadmin]);
    },
    // contract per bankholderID (customer page, admin only)
    contractRole() {
      return this.apiMode === "customer" && this.adminSuperAdmin;
    },
  },
  data() {
    return {
      tabActive: "bankaccount",
      loadingBankAccount: false,
      dataBankAccountTable: [],
      dataBankAccountTableSelect: [],
      selectStatus: "active",
      contractColumns: [
        { prop: "monthly_contract", label: "Monthly", type: "monthly" },
        { prop: "compliance_contract", label: "Compliance", type: "compliance" },
      ],
      contracts: [],
      btnActive: {
        all: true,
        active: true,
        suspended: true,
        closed: true,
      },
    };
  },
  methods: {
    getBankAccountData() {
      this.loadingBankAccount = true;
      if (this.apiMode === "project") {
        getBankAccountByProject(this.projectUID).then(({ result, data }) => {
          this.loadingBankAccount = false;
          if (result && data) {
            this.dataBankAccountTable = data;
            this.getDataSelect();
            this.$emit("numbers", data.length);
          }
        });
      } else if (this.apiMode === "customer") {
        getBankAccountByCustomer(this.customerUID).then(({ result, data }) => {
          this.loadingBankAccount = false;
          if (result && data) {
            this.dataBankAccountTable = data;
            this.setContractStatus();
            this.getDataSelect();
          }
        });
        this.getContractData();
      }
    },

    getContractData() {
      if (!this.contractRole) return;
      getContractList(this.customerUID).then(({ result, data }) => {
        if (result && data) {
          this.contracts = data;
          this.setContractStatus();
        }
      });
    },

    // set monthly_contract / compliance_contract (contract status) on each bank account row
    setContractStatus() {
      if (!this.contractRole) return;
      this.dataBankAccountTable.forEach((row) => {
        this.contractColumns.forEach((item) => {
          const contract = this.getAccountContract(row.bankholderID, item.type);
          this.$set(row, item.prop, contract ? contract.status : "inactive");
        });
      });
    },

    contractStatusText(status) {
      if (status === "active") return "ON";
      if (status === "suspended") return "SUSPENDED";
      return "OFF";
    },

    contractTagType(status) {
      if (status === "active") return "success";
      if (status === "suspended") return "warning";
      return "info";
    },

    // running (active / suspended) contract of type
    getRunningContract(type, bankholderID) {
      return this.contracts.find(
        (item) =>
          item.type === type &&
          (item.status === "active" || item.status === "suspended") &&
          (!bankholderID || item.bankholderID === bankholderID)
      );
    },

    getAccountContract(bankholderID, type) {
      return this.getRunningContract(type, bankholderID);
    },

    showContract(row, type) {
      const label = type === "monthly" ? "Monthly" : "Compliance";
      // compliance is customer-wide: only one running contract per customer
      const contract =
        type === "compliance"
          ? this.getRunningContract(type)
          : this.getAccountContract(row.bankholderID, type);

      if (!contract) {
        this.$refs.contractForm.showCreate(type, row.bankholderID, row.currency);
      } else if (contract.bankholderID !== row.bankholderID) {
        this.$alert(
          `Customer already has ${label} contract on bankholderID ${contract.bankholderID} (compliance contract is one per customer)`,
          `Contract ${label}`,
          { confirmButtonText: "OK", type: "warning" }
        );
      } else if (contract.status === "suspended") {
        this.$alert(
          `${label} contract of bankholderID ${row.bankholderID} is suspended, can't create or renew`,
          `Contract ${label}`,
          { confirmButtonText: "OK", type: "warning" }
        );
      } else {
        this.$refs.contractForm.showRenew(contract);
      }
    },

    submitedContract() {
      this.getContractData();
      this.$emit("contract-changed");
    },

    resetActiveBtn() {
      this.btnActive.all = true;
      this.btnActive.active = true;
      this.btnActive.suspended = true;
      this.btnActive.closed = true;
    },

    getDataSelect(select) {
      this.resetActiveBtn();
      this.btnActive[select] = false;
      if (select) {
        this.dataBankAccountTableSelect = findObjectArray(
          this.dataBankAccountTable,
          select,
          "status"
        );
      } else {
        this.dataBankAccountTableSelect = this.dataBankAccountTable;
      }
    },

    submitedFormBankAccount() {
      this.getBankAccountData();
    },
    balanceReload() {
      setTimeout(() => {
        this.$refs.bankBalanace.Reload();
      }, 5000);
    },
    submitedDepositTopup() {
      this.balanceReload();
    },
    showDialog(action, bankholderID) {
      this.$refs.formBankAccount.showDialog(action, bankholderID);
    },
    showDepositTopup(bankholderID, currency) {
      this.$refs.formDepositTopup.showDepositTopup(bankholderID, currency);
    },
    showTransfer(bankholderID, currency) {
      this.$refs.formTransfer.showDialogTransfer(bankholderID, currency);
    },

    showSimulatePayment() {
      this.$refs.formSimulatePayment.showDialogFakePayment();
    },

    showPayment(bankholderID, currency) {
      this.$refs.formPayment.showDialogPayment(
        bankholderID,
        currency,
        this.projectUID
      );
    },

    submitedSimulatePayment() {},

    submitedTransfer() {
      this.balanceReload();
    },

    conirmDelete(bankholderID) {
      this.$confirm(
        "Account make to closed can't be re-active again, Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          deleteBankAccount(bankholderID).then(({ result, message }) => {
            if (result) {
              this.$notify({
                title: "Success",
                message: `Close Bank account successfully`,
                type: "success",
              });
              this.getBankAccountData();
              this.balanceReload();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Close Account canceled",
          });
        });
    },

    deleteBankAccount(bankholderID) {
      getBankAccountBy(bankholderID).then(({ result, data }) => {
        if (result) {
          if (data.balance === 0) {
            this.conirmDelete(bankholderID);
          } else {
            this.$alert(
              "Balance must be zero then you can delete this bank account",
              `Balance ${data.balanceFormat} ${data.currency.toUpperCase()}`,
              {
                confirmButtonText: "OK",
                callback: (action) => {
                  this.$message({
                    type: "info",
                    message: `Delete cancel`,
                  });
                },
              }
            );
          }
        }
      });
    },
  },
  created() {
    this.getBankAccountData();
  },
};
</script>

<style lang="scss">
.customer-manager-container {
  .close-status {
    margin-right: 5px;
  }

  .el-alert {
    margin-bottom: 20px;
  }

  .btn-status {
    margin-bottom: 10px;
  }

  .contract-dropdown {
    margin-left: 10px;
  }

  // group header is not .is-leaf, match leaf header color (styles/element-ui.scss)
  .el-table th.contract-header {
    background-color: #fbfbfb;
    color: #3a8ee6;
  }
}
</style>